import React from 'react';
import { useServeFileById } from '@/hooks/upload/use-file';

interface AddImageResponseProps {
  response: {
    image?: string;
  };
  label: string;
}

const AddImageResponse: React.FC<AddImageResponseProps> = ({ response }) => {
  const { 
    data: imageUrl, 
    isLoading, 
    error 
  } = useServeFileById(response.image || '');

  if (isLoading) {
    return <div className="max-h-[320px] bg-gray-200 flex items-center justify-center">Loading...</div>;
  }

  if (error || !imageUrl) {
    return <div className="max-h-[320px] bg-gray-200 flex items-center justify-center text-gray-500">Failed to load image</div>;
  }

  return <img src={imageUrl} alt="Uploaded" className="max-h-[320px] object-cover" />;
};

export default AddImageResponse;
